import axios from "axios";
import api from "./api.js";
import { apiUrl } from "../constants/url.js";

export default class ManagerApi {
  // static async join(data) {
  //   return await api.post(`auth/sign-member`, data);
  // }

  // static async login(data) {
  //   return await api.post(`auth/login-member`, data);
  // }

  static async join(email, password, data) {
    const credentials = `${email}:${password}`;
    const encodedCredentials = btoa(credentials);

    return await axios.post(`${apiUrl}/auth/sign/admin`, data, {
      headers: {
        Authorization: `Basic ${encodedCredentials}`,
      },
    });
  }

  static async login(data) {
    const credentials = `${data.email}:${data.password}`;
    const encodedCredentials = btoa(credentials);

    return await axios.post(
      `${apiUrl}/auth/login/admin`,
      {},
      {
        headers: {
          Authorization: `Basic ${encodedCredentials}`,
        },
      }
    );
  }

  static async getMyInfo(data) {
    return await api.get(`admin-member/my/info`, data);
  }

  static async getById(id) {
    return await api.get(`admin-member/${id}`);
  }

  static async getList(data) {
    return await api.get(`admin-member`, data);
  }

  static async approve(id) {
    return await api.patch(`admin-member/approval/${id}`);
  }

  static async activation(id, data) {
    return await api.patch(`admin-member/activation/${id}`, data);
  }

  static async delete(data) {
    return await api.del(`admin-member`, data);
  }

  static async update(id, data) {
    return await api.patch(`admin-member/${id}`, data);
  }
}
